<script lang="ts" setup>
import { VButton } from '@shared/component/VButton';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import VButtonGroup from '@shared/component/VButtonGroup/VButtonGroup.vue';
import EditButton from '@relatie-lib/EditButton.vue';

const props = withDefaults(
  defineProps<{
    title: string;
    isSubmitting?: boolean;
    loading?: boolean;
    kanOpslaan?: boolean;
    kanBewerken?: boolean;
    saveButtonText?: string;
  }>(),
  { saveButtonText: 'Wijzigingen opslaan' },
);

const emit = defineEmits<{ 'edit-close': []; save: [] }>();

const isInEditMode = defineModel<boolean>('modelValue');
</script>
<template>
  <VContentBox no-padding :title="props.title">
    <template #header-end>
      <div class="flex">
        <slot name="header"></slot>
        <EditButton :title="props.title" v-if="kanBewerken" v-model="isInEditMode" />
      </div>
    </template>
    <div class="relative divide-x-0 divide-y divide-solid divide-grey-200">
      <VSkeleton class="p-4 lg:p-8" v-if="props.loading" height="lg" :count="8" />
      <div v-else class="p-4 lg:p-8"><slot></slot></div>
      <div v-if="isInEditMode" class="sticky bottom-0 bg-white p-4 lg:p-6 lg:pr-8">
        <VButtonGroup align="right">
          <VButton v-if="kanBewerken" @click="isInEditMode = false" inverted>Annuleren</VButton>
          <VButton
            :loading="props.isSubmitting"
            :disabled="!props.kanOpslaan"
            @click="emit('save')"
          >
            {{ saveButtonText }}
          </VButton>
        </VButtonGroup>
      </div>
    </div>
  </VContentBox>
</template>
